// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-product-prices',
    // #endregion
    // #region Properties
    props: {
        mode: {
            type: String,
            required: false,
            default: 'visible options'
        },
        product: {
            type: Object,
            required: false,
            default: {}
        },
        currentItem: {
            type: Object,
            required: false,
            default: {}
        },
        options: {
            type: Array,
            required: false,
            default: []
        },
        showSeperator: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data: () => ({}),
    // #endregion
    // #region Constructor
    created() {
    },
    // #endregion
    // #region Computed
    computed: {
        isVisible() {
            if (this.mode && !this.mode.includes('visible')) {
                return false;
            }
            if (!(this.product?.showPrices ?? false)) {
                return false;
            }
            if (utils.isNullOrEmpty(this.mode) || this.mode.includes('only-if-options')) {
                return this.hasOptions;
            }
            else {
                return true;
            }
        },
        hasOptions() {
            return (utils.isNullOrEmpty(this.mode) || this.mode.includes('options')) && this.options && this.options.length > 0;
        },
        getPriceFormatted() {
            if (!this.hasOptions) {
                return this.currentItem?.priceFormatted;
            }
            else if ((this.currentItem?.price ?? 0) == 0) {
                return this.currentItem?.priceFormatted;
            }
            else {
                //Vars
                let tTotal = this.currentItem?.price;
                //Fill
                this.options.forEach((e) => {
                    tTotal = tTotal + e.price;
                });
                return utils.formatNumberWithDcp(tTotal, 2) + " EUR";
            }
        }
    },
    // #endregion
    // #region Core
    methods: {},
    // #endregion
});
// #endregion
